import Player from '@vimeo/player';

export default {
  props: {
    videoId: {
      type: [String, Number],
      default: null,
    },
    autoplay: {
      type: Boolean,
      default: false,
    },
    loop: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Object,
      default: () => ({}),
    },
    playerWidth: {
      type: [String, Number],
      default: '100%',
    },
    playerHeight: {
      type: [String, Number],
      default: undefined,
    },
  },
  data() {
    return {
      player: null,
    };
  },
  watch: {
    videoId(videoId) {
      if (this.player && videoId) {
        this.player.loadVideo(videoId);
      }
    },
  },
  methods: {
    createPlayer() {
      this.player = new Player(this.$refs.mountEl, {
        id: this.videoId,
        autoplay: this.autoplay,
        loop: this.loop,
        width: this.playerWidth,
        height: this.playerHeight,
        ...this.options,
      });
      this.player.ready().then(() => this.$emit('ready'));
      this.player.on('play', () => this.$emit('playing'));
      this.player.on('pause', () => this.$emit('paused'));
      this.player.on('ended', () => this.$emit('ended'));
      this.player.on('error', (event) => this.$emit('error', event));
    },
  },
  mounted() {
    this.createPlayer();
  },
  beforeDestroy() {
    if (this.player) {
      this.player.destroy();
      this.player = null;
    }
  },
};



// WEBPACK FOOTER //
// ./src/components/generics/vimeo-player/vimeo-player.js